import { getOverridesFromQuery } from './getOverridesFromQuery';
import safeParseObjectFromSessionStorage from './safeParseObjectFromSessionStorage';
import { OVERRIDE_SESSION_STORAGE_KEY } from '../providers/RemoteOverridesProvider';

export const getRemoteOverrides = () => {
  const overridesFromQuery = getOverridesFromQuery();
  const hasOverridesFromQuery = Boolean(Object.keys(overridesFromQuery).length);

  const overridesFromSessionStorage = safeParseObjectFromSessionStorage(
    OVERRIDE_SESSION_STORAGE_KEY,
  ) as Record<string, string> | null;

  if (overridesFromSessionStorage && !hasOverridesFromQuery) {
    return overridesFromSessionStorage;
  } else if (overridesFromSessionStorage && hasOverridesFromQuery) {
    const newOverrides = Object.assign(
      overridesFromSessionStorage,
      overridesFromQuery,
    );
    sessionStorage.setItem(
      OVERRIDE_SESSION_STORAGE_KEY,
      JSON.stringify(newOverrides),
    );

    return newOverrides;
  } else if (hasOverridesFromQuery) {
    sessionStorage.setItem(
      OVERRIDE_SESSION_STORAGE_KEY,
      JSON.stringify(overridesFromQuery),
    );

    return overridesFromQuery;
  }

  return {};
};

export const getRawRemoteOverride = (scope: string) => ({
  url: getRemoteOverrides()[scope],
});
export const hasOverrides = () =>
  Boolean(Object.keys(getRemoteOverrides()).length);
